import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { dataPeriodoEdicao } from '../../../../domain/models/periodo_anual';

type Props = {
  label: string;
  value: Date | string | null | undefined;
  onChange: (value: Date | null) => void;
  onBlur?: () => void;
  error?: string;
  required?: boolean;
};

/** Seletor independente: permite término anterior ao início (virada do ano). */
export const PeriodoAnualDatePicker = ({ label, value, onChange, onBlur, error, required }: Props) => (
  <DatePicker
    label={label}
    views={['month', 'day']}
    format="DD/MM"
    referenceDate={dayjs(new Date(2001, 0, 1, 12))}
    value={value ? dayjs(dataPeriodoEdicao(value)) : null}
    shouldDisableDate={date => date.month() === 1 && date.date() === 29}
    onChange={(date, context) => {
      if (date === null) onChange(null);
      else onChange(context.validationError || !date.isValid() ? new Date(NaN) : date.toDate());
    }}
    slotProps={{
      field: { clearable: true, onClear: () => onChange(null) },
      textField: { size: 'small', fullWidth: true, required, error: !!error, helperText: error, onBlur },
    }}
  />
);
